import { tns } from 'tiny-slider';
export function navigationSlider() {

    ;(function(){
        const throttle = function(type, name, obj){
            obj = obj || window;
            let running = false;
            let func = function(){
                if (running){ return; }
                running = true;
                requestAnimationFrame(function(){
                    obj.dispatchEvent(new CustomEvent(name));
                    running = false;
                });
            };
            obj.addEventListener(type, func);
        };

        throttle('scroll', 'optimizedScroll');
    }) ();

    let slider = document.getElementById('navigation-slider');
    if (slider) {
        slider = tns({
            container: '#navigation-slider',
            items: 1,
            gutter: 0,
            autoplay: false,
            nav: false,
            navPosition: 'bottom',
            mouseDrag: true,
            touch: true,
            controls: false,
            controlsPosition: 'bottom',
            controlsText: ['<span class="icon-basic icon-chevron-left-circled"></span>', '<span class="icon-basic icon-chevron-right-circled"></span>'],
            responsive: {
                850: {
                    items: 3,
                    edgePadding: 0
                },
                1480: {
                    items: 1,
                    edgePadding: 150,
                },
                1680: {
                    edgePadding: 0,
                    center: true,
                    items: 3
                },
                2400: {
                    items: 3
                }
            }
        });

        let info = slider.getInfo();
        let container = info.container;
        let scrolling = false; // Debounce flag

        container.addEventListener('wheel', function(event) {
            event.preventDefault();

            // Check if scrolling is already in progress
            if (!scrolling) {
                scrolling = true; // Lock scrolling

                if (event.deltaY < 0) {
                    slider.goTo('prev'); // Scroll to the previous item
                } else if (event.deltaY > 0) {
                    slider.goTo('next'); // Scroll to the next item
                }

                // Unlock scrolling after 200ms (or desired debounce delay)
                setTimeout(function() {
                    scrolling = false;
                }, 400);
            }
        });


        let steps = document.querySelectorAll('.steps__heading');
        const nav = document.querySelector('.steps-navigation');

        // Function to get the index of the current section in view
        function setActiveMenuItem() {

            let currentIndex = -1;

            steps.forEach((step, index) => {
                const stepTop = step.getBoundingClientRect().top;
                if (stepTop < 500) {
                    currentIndex = index;
                }
            });

            // Update active menu item based on current section index
            if (currentIndex !== -1 && nav.getBoundingClientRect().top <= 50) {
                // Update slider to the current index
                updateSlider(currentIndex);
            }
        }

        // Function to update the slider (assuming it takes an index as input)
        function updateSlider(index) {
            // Example for a basic slider with a method to move to a specific slide
            // This will depend on the slider library or implementation you use
            if (slider) {
                slider.goTo(index);
            } else {
                console.warn("Slider does not have a 'moveToSlide' method");
            }
        }

        // Run the function on scroll
        window.addEventListener('optimizedScroll', setActiveMenuItem);

    }

    return 'navigationSlider';

}
